import * as React from 'react';
import { TransitionGroup } from 'react-transition-group';

import { Notification } from './components/Notification';
import { NotificationWrapper } from './components/NotificationWrapper';
import * as styles from './Notifications.css';
import { INotification } from '../../types/notifications';
import { Portal } from '../Portal';

interface INotificationsProps {
  notifications: INotification[];
  onNotificationRemove(notification: INotification): void;
}

export const Notifications: React.FC<INotificationsProps> = ({ notifications, onNotificationRemove }) => {
  return (
    <Portal>
      <div className={styles['container']}>
        <TransitionGroup component={null}>
          {notifications.map(item => {
            const removeNotification = () => onNotificationRemove(item);

            return (
              <NotificationWrapper key={item.id} onCloseRequest={removeNotification} timeout={item.timeout}>
                <Notification message={item.message} onClick={removeNotification} />
              </NotificationWrapper>
            );
          })}
        </TransitionGroup>
      </div>
    </Portal>
  );
};
